import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import { useRouter } from 'next/router'
import useContent from 'store/content'
import Button from 'components/Button'
import Toast from 'components/Toast'
import Templator from 'utils/Templator'
import { useTheme } from 'styled-components'
import { withTranslation } from 'react-i18next'
import { getUserInput, saveUserInput, triggerEmail } from 'libs/localApi'
import { isLinkInternal, removeDomainFromLink, setCurrentDomainToLink } from 'utils/index'
import test from './test.json'

import { MdError } from 'react-icons/md'

import Validation from './Validation'
import { StyledLoader } from './styles'

import dynamic from 'next/dynamic'

const PdfViewer = dynamic(() => import('components/PdfViewer'), { ssr: false })



const Lotodemoembed = ({ appId, id, type, typeId, t }) => {

  const InlineImage = ({ src, alt = '', width = 25, height = 25, style = {} }) => (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      style={{ verticalAlign: 'middle', margin: '0 6px', display: 'inline-block', ...style }}
    />
  )
  const InlineImageString = ({ src, alt = '', width = 275, height = 25, style = {} }) => (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      style={{ verticalAlign: 'middle', margin: '0 6px', display: 'inline-block', ...style }}
    />
  )

  const bgUrl = encodeURI('/images/background_dancing_drumspng.png')

  const background = {
    backgroundImage: `url("${bgUrl}")`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    padding: '20px',
  }

  const contentStyle = {
    backgroundColor: 'rgba(255,255,255,0.95)',
    padding: '10px',
    borderRadius: '6px',
    boxShadow: '0 6px 18px rgba(0,0,0,0.12)',
  }
  
  const styleMap = {
    background: {
      backgroundImage: `url("/images/background_dancing_drumspng.png")`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      padding: '20px',
    },
    contentStyle: {
      backgroundColor: 'rgba(255,255,255,0.95)',
      padding: '10px',
      borderRadius: '6px',
      boxShadow: '0 6px 18px rgba(0,0,0,0.12)',
    }
  };

  const renderElement = (node) => {
    if (!node) return null;
    const { type, style, text, children, inlineImages, strong } = node;
    if (!type) return null;

    const Tag = type;
    const resolvedStyle = typeof style === 'string' ? styleMap[style] : style;

    if (text) {
      return (
        <Tag style={resolvedStyle}>
          {strong ? <strong>{text}</strong> : text}
          {inlineImages &&
            inlineImages.map((src, i) => (
              <InlineImage key={i} src={src} alt="symbole" />
            ))}
        </Tag>
      );
    }

    return (
      <Tag style={resolvedStyle}>
        {children && children.map((child, i) => renderElement(child))}
      </Tag>
    );
  };

  return (
    <div>
      { id === "A" && <PdfViewer src="/Dancing_Drums.pdf" pageWidth={500} />}
      { id === "B" && <PdfViewer src="/Affiche_Kingdom_Of_Horus.pdf" pageWidth={494} />}
      { id === "C" && <PdfViewer src="/Double_Diamond_Stars.pdf" pageWidth={500} />}
    </div>
  )
}

Lotodemoembed.propTypes = {
  appId: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  typeId: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
}

export default withTranslation()(Lotodemoembed)
